export var CHANNEL_ID_ENUM;
(function(CHANNEL_ID_ENUM2) {
  CHANNEL_ID_ENUM2["AKULAKU"] = "AKULAKU_ID";
  CHANNEL_ID_ENUM2["BLIBLI"] = "BLIBLI_ID";
  CHANNEL_ID_ENUM2["BUKALAPAK"] = "BUKALAPAK_ID";
  CHANNEL_ID_ENUM2["JD_ID"] = "JD_ID";
  CHANNEL_ID_ENUM2["JD_V2"] = "JD_V2";
  CHANNEL_ID_ENUM2["JD_TH"] = "JD_TH";
  CHANNEL_ID_ENUM2["LAZADA"] = "LAZADA_ID";
  CHANNEL_ID_ENUM2["SHOPEE"] = "SHOPEE_ID";
  CHANNEL_ID_ENUM2["SHOPIFY"] = "SHOPIFY_ID";
  CHANNEL_ID_ENUM2["TIKI"] = "TIKI_ID";
  CHANNEL_ID_ENUM2["TIKTOK"] = "TIKTOK_ID";
  CHANNEL_ID_ENUM2["TOKOPEDIA"] = "TOKOPEDIA_ID";
  CHANNEL_ID_ENUM2["WOO_COMMERCE"] = "WOO_COMMERCE_ID";
  CHANNEL_ID_ENUM2["MAGENTO"] = "MAGENTO_ID";
  CHANNEL_ID_ENUM2["WIX"] = "WIX_ID";
  CHANNEL_ID_ENUM2["ZALORA"] = "ZALORA_ID";
  CHANNEL_ID_ENUM2["ALIEXPRESS"] = "ALIEXPRESS_ID";
  CHANNEL_ID_ENUM2["JAKMALL"] = "JAKMALL_ID";
  CHANNEL_ID_ENUM2["MOKA"] = "MOKA_POS_ID";
  CHANNEL_ID_ENUM2["MANUAL"] = "MANUAL_ID";
  CHANNEL_ID_ENUM2["LINE_SHOPPING"] = "LINE_SHOPPING_TH";
  CHANNEL_ID_ENUM2["GINEE_POS"] = "GINEE_POS";
})(CHANNEL_ID_ENUM || (CHANNEL_ID_ENUM = {}));
export var CHANNEL_NAME_ENUM;
(function(CHANNEL_NAME_ENUM2) {
  CHANNEL_NAME_ENUM2["AKULAKU_ID"] = "Akulaku";
  CHANNEL_NAME_ENUM2["BLIBLI_ID"] = "Blibli";
  CHANNEL_NAME_ENUM2["BUKALAPAK_ID"] = "Bukalapak";
  CHANNEL_NAME_ENUM2["JD_V2"] = "JD";
  CHANNEL_NAME_ENUM2["JD_ID"] = "JD.ID";
  CHANNEL_NAME_ENUM2["JD_TH"] = "JD.TH";
  CHANNEL_NAME_ENUM2["LAZADA_ID"] = "Lazada";
  CHANNEL_NAME_ENUM2["SHOPEE_ID"] = "Shopee";
  CHANNEL_NAME_ENUM2["SHOPIFY_ID"] = "Shopify";
  CHANNEL_NAME_ENUM2["TIKI_ID"] = "Tiki";
  CHANNEL_NAME_ENUM2["TIKTOK_ID"] = "TikTok";
  CHANNEL_NAME_ENUM2["TOKOPEDIA_ID"] = "Tokopedia";
  CHANNEL_NAME_ENUM2["WOO_COMMERCE_ID"] = "WooCommerce";
  CHANNEL_NAME_ENUM2["ZALORA_ID"] = "Zalora";
  CHANNEL_NAME_ENUM2["LINE_SHOPPING_TH"] = "Line Shopping";
  CHANNEL_NAME_ENUM2["ALIEXPRESS_ID"] = "AliExpress";
  CHANNEL_NAME_ENUM2["JAKMALL_ID"] = "Jakmall";
  CHANNEL_NAME_ENUM2["MOKA_POS_ID"] = "Moka POS";
  CHANNEL_NAME_ENUM2["MANUAL_ID"] = "Manual";
  CHANNEL_NAME_ENUM2["WIX_ID"] = "Wix";
})(CHANNEL_NAME_ENUM || (CHANNEL_NAME_ENUM = {}));
export var CHANNEL_SORT_PRIORITY;
(function(CHANNEL_SORT_PRIORITY2) {
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["SHOPEE_ID"] = 0] = "SHOPEE_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["TOKOPEDIA_ID"] = 1] = "TOKOPEDIA_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["LAZADA_ID"] = 2] = "LAZADA_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["TIKTOK_ID"] = 3] = "TIKTOK_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["BUKALAPAK_ID"] = 4] = "BUKALAPAK_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["BLIBLI_ID"] = 5] = "BLIBLI_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["JD_V2"] = 6] = "JD_V2";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["JD_ID"] = 7] = "JD_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["JD_TH"] = 8] = "JD_TH";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["TIKI_ID"] = 9] = "TIKI_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["ZALORA_ID"] = 10] = "ZALORA_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["LINE_SHOPPING_TH"] = 11] = "LINE_SHOPPING_TH";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["SHOPIFY_ID"] = 12] = "SHOPIFY_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["WOO_COMMERCE_ID"] = 13] = "WOO_COMMERCE_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["MAGENTO_ID"] = 14] = "MAGENTO_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["WIX_ID"] = 15] = "WIX_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["AKULAKU_ID"] = 16] = "AKULAKU_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["ALIEXPRESS_ID"] = 17] = "ALIEXPRESS_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["JAKMALL_ID"] = 18] = "JAKMALL_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["MOKA_POS_ID"] = 19] = "MOKA_POS_ID";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["GINEE_POS"] = 20] = "GINEE_POS";
  CHANNEL_SORT_PRIORITY2[CHANNEL_SORT_PRIORITY2["MANUAL_ID"] = 21] = "MANUAL_ID";
})(CHANNEL_SORT_PRIORITY || (CHANNEL_SORT_PRIORITY = {}));
